import styled from 'styled-components';
import { Modal, Spin } from 'antd';
import { blueDark01 } from '../../../../../../styles/colors';

export const HideGuidelineProductModalContainer = styled(Modal)`
    width: 50vw !important;
    .ant-modal-content {
        border-radius: 8px;
        padding: 32px;
    }
`;

export const HideGuidelineProductModalSpin = styled(Spin)`
    width: 100%;
`;

export const ModalBody = styled.div`
    margin-top: 16px;
`;

export const ModalText = styled.p`
    font-size: 15px;
    color: ${blueDark01};
    margin-bottom: 12px;

    strong {
        font-family: 'Proxima N W15 Bold';
        font-weight: 400;
    }
`;

export const ModalList = styled.ul`
    margin: 0 0 16px 0;
    padding-left: 20px;

    li {
        font-size: 15px;
        color: ${blueDark01};
        margin-bottom: 6px;
        list-style-type: disc;
    }
`;

export const ModalNote = styled.p`
    font-size: 15px;
    color: ${blueDark01};
    margin-bottom: 20px;
`;
